import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Table } from "react-bootstrap";
import ApiManager from "../utils/ApiManager"; // Adjust the path as per your directory structure
import "./Modal.css";
import RowCountLabel from "./RowCountLabel";
import DataManager from "../utils/DataManager";
import FlagIcon from "@mui/icons-material/Flag";

const ModalStockChanges = ({ productId, showModal, onCloseModal }) => {
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [stockChanges, setStockChanges] = useState([]);

  useEffect(() => {
    if (showModal) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  const fetchData = () => {
    setError(null);
    ApiManager.Top.stockChanges(
      {
        productId: productId,
      },
      (data) => {
        let tmpStockChanges = data?.stockChanges || [];
        setStockChanges(tmpStockChanges);
      },
      (error) => {
        setError(error);
      },
      () => {}
    );
  };

  const handleCloseModal = () => {
    onCloseModal(false);
  };

  const getRowColor = (movReason) => {
    return movReason === -1 ? "text-danger" : "text-success";
  };

  let lastRowPos = "";
  let posTotalQty = 0;

  return (
    <Modal
      className="incomingModals"
      show={showModal}
      onHide={handleCloseModal}
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <strong className="header-text">
          Storico movimenti articolo {productId}
        </strong>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <RowCountLabel count={stockChanges?.length} label="Movimenti" />
            <Table striped>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Documento</th>
                  <th>Ubicazione</th>
                  <th className="text-end" style={{ width: "170px" }}>
                    Qta
                  </th>
                  <th>Cliente</th>
                  <th>Fornitore</th>
                  <th className="text-end" style={{ width: "100px" }}>
                    Anno
                  </th>
                </tr>
              </thead>
              <tbody>
                {stockChanges?.map((row, rowindex) => {
                  if (!lastRowPos) {
                    lastRowPos =
                      row.warehouseAreaDescr +
                      "-" +
                      row.rack +
                      "-" +
                      row.col +
                      "-" +
                      row.shelf;
                  }
                  let endDataset = rowindex === stockChanges.length - 1;
                  if (endDataset) {
                    posTotalQty += row.qty * row.movReason;
                  }
                  let lastLine =
                    lastRowPos !==
                    row.warehouseAreaDescr +
                      "-" +
                      row.rack +
                      "-" +
                      row.col +
                      "-" +
                      row.shelf;
                  let result = (
                    <React.Fragment key={`row-${row.id}`}>
                      {lastLine && (
                        <tr className="fw-bold">
                          <td colSpan="1"></td>
                          <td className="text-end">TOTALE</td>
                          <td>{lastRowPos}</td>
                          <td className="text-end">
                            {DataManager.Decimal.format(posTotalQty, 0)}
                          </td>
                          <td colSpan="3"></td>
                        </tr>
                      )}
                      {/* <tr style={{ verticalAlign: "middle" }}> */}
                      <tr className="align-middle">
                        <td className={getRowColor(row.movReason)}>
                          {DataManager.Date.format(
                            row.createdOn,
                            "dd/MM/yyyy HH:mm:ss"
                          )}
                        </td>
                        <td className={getRowColor(row.movReason)}>
                          <ul className="list-unstyled">
                            <li>
                              {row.initialLoad
                                ? "Carico iniziale"
                                : "Lista " + row.pickingListDescr}
                            </li>
                            {row.pickingListIsStockMovement ? (
                              <li>
                                  <span className="half-parent-text">
                                  Mov. interna
                                  </span>
                                  </li>
                            ) : (
                              <>
                                <li>
                                  {row.docTypeDescr}&nbsp;
                                  {row.docNumb}
                                  {row.docSeries?.trim()
                                    ? "/" + row.docSeries
                                    : ""}
                                  &nbsp;
                                  {DataManager.Date.format(
                                    row.docDate,
                                    "dd/MM/yyyy"
                                  )}
                                </li>
                                <li>
                                  <span className="half-parent-text">
                                    {row.transpReasonDescr}
                                  </span>
                                </li>
                              </>
                            )}
                          </ul>
                        </td>
                        <td className={getRowColor(row.movReason)}>
                          {row.warehouseAreaDescr}-{row.rack}-{row.col}-
                          {row.shelf}
                        </td>
                        <td
                          className={getRowColor(row.movReason) + " text-end"}
                        >
                          {row.initialLoad ? (
                            <div
                              className="d-flex justify-content-between align-items-center"
                              title="Carico iniziale"
                            >
                              <FlagIcon />
                              {DataManager.Decimal.format(
                                row.qty * row.movReason,
                                0
                              )}
                            </div>
                          ) : (
                            DataManager.Decimal.format(
                              row.qty * row.movReason,
                              0
                            )
                          )}
                        </td>
                        <td className={getRowColor(row.movReason)}>
                          <ul className="list-unstyled">
                            <li>{row.customerDescr}</li>
                            <li>
                              <span className="half-parent-text">
                                {row.customerId}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td className={getRowColor(row.movReason)}>
                          <ul className="list-unstyled">
                            <li>{row.supplierDescr}</li>
                            <li>
                              <span className="half-parent-text">
                                {row.supplierId}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td
                          className={getRowColor(row.movReason) + " text-end"}
                        >
                          {DataManager.Decimal.format(row.productYear, 0)}
                        </td>
                      </tr>
                      {endDataset && (
                        <tr className="fw-bold">
                          <td colSpan="1"></td>
                          <td className="text-end">TOTALE</td>
                          <td>{lastRowPos}</td>
                          <td className="text-end">
                            {DataManager.Decimal.format(posTotalQty, 0)}
                          </td>
                          <td colSpan="3"></td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                  if (lastLine) {
                    posTotalQty = 0;
                  }
                  lastRowPos =
                    row.warehouseAreaDescr +
                    "-" +
                    row.rack +
                    "-" +
                    row.col +
                    "-" +
                    row.shelf;
                  posTotalQty += row.qty * row.movReason;
                  return result;
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ModalStockChanges;
